import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';
import { useCallback } from 'react';
import { AxiosError } from 'axios';
import { translations } from 'translations';
import { ERROR_TOAST_DEFAULTS } from '@helpers';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const useFetchIdentityVerificationUrl = ({
  folder,
  document,
  token,
  team,
  invite,
  enabled,
}) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const { team: defaultTeam } = useSession();

  const toast = useToast();

  const { t } = useTranslation();

  const teamUUID = defaultTeam?.uuid as string;

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);
      if (error?.response?.status === 403) {
        msg = t(
          translations.DOCUMENT_PAGES.IDENTITY_VERIFICATION_STATUS_CODE_403,
        );
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const fn = async () => {
    const response = await client.fetchIdentityVerification(
      team ?? teamUUID,
      folder,
      document,
      invite,
    );
    return response;
  };

  const resolvedToken = resolveTokenV3(token);

  const finalTeam = team ?? teamUUID;

  const query = useQuery(
    ['identity-verification-url', finalTeam, folder, document, resolvedToken],
    fn,
    {
      enabled: Boolean(
        enabled && finalTeam && folder && document && resolvedToken,
      ),
      onError,
    },
  );

  return { ...query };
};
